import styles from './ReportMetadata.module.css';

interface PropsObject {
  title: string;
  metadata: string;
}

function ReportMetadata(props: Readonly<PropsObject>) {
  return (
    <div className="row">
      <div className={`lg-8 md-12 sm-12 ${styles.midPanel}`}>
        <p className={styles.subtitle}>{props.metadata}</p>
      </div>
    </div>
  );
}
export default ReportMetadata;
